module.exports = __webpack_public_path__ + "static/media/profile.225653f9.jpg";